module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_02_C.2a7e7b10.png";